import { Case } from '../../../beans/Case';
import { File } from '../../../beans/File';
import { Component, OnInit, Input, ViewContainerRef, Host } from '@angular/core';
import { BlockUiService } from '../../../services/blockui.service';
import { CaseService } from '../../../services/case.service';
import { FileService } from '../../../services/file.service';
import { NomenclatureService } from '../../../services/nomenclature.service';
import { EditCaseComponent } from '../edit-case.component';
import { DatePipe } from '@angular/common';

@Component({
	selector: 'app-library',
	templateUrl: './library.component.html',
	styleUrls: ['./library.component.scss']
})
export class LibraryComponent implements OnInit {
	private _caseid;
	fileRows: Array<File>;
	file: string;
	event: EventTarget;
	opisanie: string;

	public cols = [
		{ title: 'Upload date', name: 'createdDate', dataType: 'date' },
		{ title: 'Описание на файла', name: 'opisanie' },
		{ title: 'Име на файла', name: 'file' },
	];

	constructor(
		private caseService: CaseService,
		private fileService: FileService,
		private blockUi: BlockUiService,
		private vcRef: ViewContainerRef,
		private datePipe: DatePipe,
		@Host() private parentComp: EditCaseComponent ) { }


	ngOnInit() {
		this.loadTable();
	}
	
	@Input()
	public set editedCase(val: Case) {
		this.edit(val);
	}

	loadTable() {
		this.blockUi.start(this.vcRef);
		this.fileRows = new Array<File>();
		this.fileService.getFiles(this._caseid).subscribe(
			files => {
				this.fileRows = new Array<File>();
				for (let i = 0; i < files.length; i++) {
					this.fileRows[i] = files[i].file;
					this.fileRows[i].signUrl = files[i].signUrl;
				}
				this.blockUi.stop();
			},
			error => {
				this.blockUi.stop();
			});
	}

	private refresh() {
		this.file = this.file;
	}

	private edit(caseObj: Case): void {
		this.refresh();
		if (caseObj && caseObj.id) {
			this._caseid = caseObj.id;
		}
	}
	changeFile(e) {
		this.event = e;
		this.file = e.target.files[0].name;
	}
	public downloadFile(selectedFile: File) {
		window.open(selectedFile.signUrl);
	}

	public addFile() {
		this.blockUi.start(this.vcRef);
		if (this.event && this._caseid && this.file) {
			this.fileService.addFile(this.event, this._caseid, this.file, this.opisanie).subscribe(
				result => {
					this.blockUi.stop();
					alert('Файлът Беше Добавен');
					this.refresh();
					this.loadTable();
				},
				error => {
					this.blockUi.stop();
					alert('Възникна Грешка. Файлът не беше добавен.');
				});
		} else {
			alert('Нямате избран файл.');
		}
	}

	public delete(selectedFile: File) {
		if (confirm('Сигурни ли сте, че искате да изтриете?')) {
			this.blockUi.start(this.vcRef);
			this.fileService.deleteFile(selectedFile.id).subscribe(
				result => {
					this.blockUi.stop();
					this.loadTable();
					alert('Файлът Беше Изтрит успешно');
				},
				error => {
					alert('Възникна Грешка');
					this.blockUi.stop();
				});
		}
	}
}
